import { createSlice } from '@reduxjs/toolkit'
import { getRequest ,getMockyRequest} from 'services/axiosBaseClient';

const axios = require("axios");
const API_URL = "https://jsonplaceholder.typicode.com/todos";

export const vehicleSlice = createSlice({
  name: "vehicleList",
  initialState: {
    data: []
  },
  reducers: {
    fetchVehicleList: (state, action) => {
      state.data = action.payload;
    }
    // ,
    // getTodo: (state, action) => {
    //   state.data = [action.payload];
    // }
  }
});

export const vehicledropdownTodoAsync = (data) => async (dispatch) => {
  try {
    // getMockyRequest('https://run.mocky.io/v3/738eb9e1-101a-417a-bd83-2a0861627f14').then((response) => {
    getRequest('fleets/vehicles').then((response) => {
    if (response.status === 200) {
      let dataArray=response?.data?.fleetVehicle
      let chargerArray = [{ label: "Select All", value: '0',vehID:'0', fleetId: '' }];
      dataArray.map((item) => {
        
        for(let prop of chargerArray){
          if(prop.label === item?.name){
            var includes = true;
          } else {
            includes = false;
          }
        }
        if(includes === false){
        chargerArray.push({ label: item?.name,name:'vehicle', value: item?.id, fleetId: item?.fleet?.id,timeZone:item?.fleet?.timezone });
        }
      })
     
      dispatch(fetchVehicleList(chargerArray));
      
    } else {
      return ["vaibhav"]
    }
}).catch((err) => {
  console.error("Error Redux", err)
})
}
 catch (err) {
  throw new Error(err);
}
}




export const { fetchVehicleList } = vehicleSlice.actions
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const getVehicleList = (state) => state?.vehicleList?.data

export default vehicleSlice.reducer